// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */
.sidebar {
    position: fixed;
    left: 0;
    top: 10px;
    bottom: 10px;
    background: #2C3E50;
    z-index: 3;
    transition: width 0.1s;
    overflow: hidden;
    border-radius: 10px; /* Rounded corners */
    box-shadow: 5px 0 15px rgba(0,0,0,0.7); /* Shadow for depth */
    display: flex;
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items horizontally */
  }
  
  .app {
    display: flex;
  }
  
  .sidebar.expanded {
    width: 180px;
  }
  
  .sidebar.collapsed {
    width: 50px;
  }
  
  .label {
    color: aliceblue;
    text-align: center; /* Center the text inside label */
  }
  
  .toggle-button {
    width: 100%;
    background-color: #34495E; /* Darker blue for button */
    color: white; /* Button text color */
    padding: 10px; /* Button padding */
    border: none; /* Remove border */
    border-bottom: 1px solid #ebd5d5; /* Bottom border for separation */
    border-top-left-radius: 10px; /* Rounded corners at the top */
    border-top-right-radius: 10px; /* Rounded corners at the top */
    cursor: pointer; /* Cursor pointer on hover */
    outline: none; /* Remove outline */
  }
  
  .menu-item {
    display: flex;
    flex-direction: row; /* Arrange label and emoji in a row */
    justify-content: center; /* Center items horizontally */
    align-items: center; /* Center items vertically */
    width: 100%; /* Full width to match sidebar */
    color: #ECF0F1; /* Light grey text color */
    background-color: #2C3E50; /* Dark blue background */
    padding: 10px 0; /* Add some padding */
    transition: background-color 0.3s, color 0.3s; /* Smooth transition for colors */
  }
  
  /* Hover state for the menu item */
  .menu-item:hover {
    background-color: #34495E; /* Darker blue background on hover */
  color: #F1C40F; /* Gold text color on hover */
    }

    /* Active state for the menu item */
.menu-item.active {
    background-color: #2980B9; /* Bright blue background when active */
    color: #FFFFFF; /* White text color when active */
    border: 2px solid #999; /* Border when active */
  }

  .emoji {
    font-size: 24px; /* Emoji size */
    margin-right: 10px; /* Space between emoji and label */
  }
  
  /* Add hover effects for buttons */
  .toggle-button:hover {
    background-color: #555; /* Darker background on hover */
    color: #fff; /* White text color on hover */
  }
  
  /* Additional styling for menu items */
  .menu-item:hover {
    background-color: #cadfe773;
  }
  
  .menu-item .emoji, .menu-item .label {
    display: flex;
    align-items: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB,EAAE,oBAAoB;IACzC,sCAAsC,EAAE,qBAAqB;IAC7D,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB,EAAE,8BAA8B;EACrD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA;IACE,WAAW;IACX,yBAAyB,EAAE,2BAA2B;IACtD,YAAY,EAAE,sBAAsB;IACpC,aAAa,EAAE,mBAAmB;IAClC,YAAY,EAAE,kBAAkB;IAChC,gCAAgC,EAAE,iCAAiC;IACnE,4BAA4B,EAAE,+BAA+B;IAC7D,6BAA6B,EAAE,+BAA+B;IAC9D,eAAe,EAAE,4BAA4B;IAC7C,aAAa,EAAE,mBAAmB;EACpC;;EAEA;IACE,aAAa;IACb,mBAAmB,EAAE,qCAAqC;IAC1D,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,4BAA4B;IACjD,WAAW,EAAE,gCAAgC;IAC7C,cAAc,EAAE,0BAA0B;IAC1C,yBAAyB,EAAE,yBAAyB;IACpD,eAAe,EAAE,qBAAqB;IACtC,6CAA6C,EAAE,iCAAiC;EAClF;;EAEA,kCAAkC;EAClC;IACE,yBAAyB,EAAE,oCAAoC;EACjE,cAAc,EAAE,6BAA6B;IAC3C;;IAEA,mCAAmC;AACvC;IACI,yBAAyB,EAAE,uCAAuC;IAClE,cAAc,EAAE,iCAAiC;IACjD,sBAAsB,EAAE,uBAAuB;EACjD;;EAEA;IACE,eAAe,EAAE,eAAe;IAChC,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA,kCAAkC;EAClC;IACE,sBAAsB,EAAE,+BAA+B;IACvD,WAAW,EAAE,8BAA8B;EAC7C;;EAEA,sCAAsC;EACtC;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB","sourcesContent":["/* Sidebar.css */\n.sidebar {\n    position: fixed;\n    left: 0;\n    top: 10px;\n    bottom: 10px;\n    background: #2C3E50;\n    z-index: 3;\n    transition: width 0.1s;\n    overflow: hidden;\n    border-radius: 10px; /* Rounded corners */\n    box-shadow: 5px 0 15px rgba(0,0,0,0.7); /* Shadow for depth */\n    display: flex;\n    flex-direction: column; /* Stack items vertically */\n    align-items: center; /* Center items horizontally */\n  }\n  \n  .app {\n    display: flex;\n  }\n  \n  .sidebar.expanded {\n    width: 180px;\n  }\n  \n  .sidebar.collapsed {\n    width: 50px;\n  }\n  \n  .label {\n    color: aliceblue;\n    text-align: center; /* Center the text inside label */\n  }\n  \n  .toggle-button {\n    width: 100%;\n    background-color: #34495E; /* Darker blue for button */\n    color: white; /* Button text color */\n    padding: 10px; /* Button padding */\n    border: none; /* Remove border */\n    border-bottom: 1px solid #ebd5d5; /* Bottom border for separation */\n    border-top-left-radius: 10px; /* Rounded corners at the top */\n    border-top-right-radius: 10px; /* Rounded corners at the top */\n    cursor: pointer; /* Cursor pointer on hover */\n    outline: none; /* Remove outline */\n  }\n  \n  .menu-item {\n    display: flex;\n    flex-direction: row; /* Arrange label and emoji in a row */\n    justify-content: center; /* Center items horizontally */\n    align-items: center; /* Center items vertically */\n    width: 100%; /* Full width to match sidebar */\n    color: #ECF0F1; /* Light grey text color */\n    background-color: #2C3E50; /* Dark blue background */\n    padding: 10px 0; /* Add some padding */\n    transition: background-color 0.3s, color 0.3s; /* Smooth transition for colors */\n  }\n  \n  /* Hover state for the menu item */\n  .menu-item:hover {\n    background-color: #34495E; /* Darker blue background on hover */\n  color: #F1C40F; /* Gold text color on hover */\n    }\n\n    /* Active state for the menu item */\n.menu-item.active {\n    background-color: #2980B9; /* Bright blue background when active */\n    color: #FFFFFF; /* White text color when active */\n    border: 2px solid #999; /* Border when active */\n  }\n\n  .emoji {\n    font-size: 24px; /* Emoji size */\n    margin-right: 10px; /* Space between emoji and label */\n  }\n  \n  /* Add hover effects for buttons */\n  .toggle-button:hover {\n    background-color: #555; /* Darker background on hover */\n    color: #fff; /* White text color on hover */\n  }\n  \n  /* Additional styling for menu items */\n  .menu-item:hover {\n    background-color: #cadfe773;\n  }\n  \n  .menu-item .emoji, .menu-item .label {\n    display: flex;\n    align-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
